import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Tab, Nav, NavItem, NavDropdown, MenuItem } from 'react-bootstrap';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { customerJourneyNewsCategory } from '../../../actions';

import './newscategoryexplorer.scss';

class NewsCategoryExplorer extends React.Component {

  constructor(props) {
    super(props);

    this.handleOnSelectCategory = this.handleOnSelectCategory.bind(this);
  }

  /* Handlers */
  handleOnSelectCategory(activeKey) {
    this.props.actions.customerJourneyNewsCategory(activeKey, this.props.token, this.props.currentLanguage, this.props.context);
    this.props.onChangeCurrentCategoryId(activeKey);
  }

  render() {

    let navItems = [];
    let menuItems = [];

    if(this.props.newsCategories.apiData.length > 0) {
      this.props.newsCategories.apiData.forEach((newsCategory, index) => {
        const categoryLabel = <span><img width={16} height={16} src={newsCategory.picture} alt={newsCategory.name}/> {newsCategory.name.toUpperCase()}</span>;
        navItems.push(<NavItem className="hidden-xs hidden-sm" key={newsCategory.id} eventKey={newsCategory.id}>{categoryLabel}</NavItem>);
        menuItems.push(<MenuItem key={newsCategory.id} eventKey={newsCategory.id}>{categoryLabel}</MenuItem>);
      });
    }
    else {
      navItems.push(<NavItem key={0} className="hidden-xs hidden-sm" eventKey="loading" disabled><i className="fa fa-ellipsis-h fa-fw"></i></NavItem>);
      menuItems.push(<MenuItem key={0} className="hidden-xs hidden-sm" eventKey="loading"><i className="fa fa-ellipsis-h fa-fw"></i></MenuItem>)
    }

    return (
      <Tab.Container id="news-category-tabs" activeKey={this.props.currentCategoryId} onSelect={this.handleOnSelectCategory} className="news-newscategoryexplorer-component">
        <Row className="clearfix">
          <Col xs={12}>
            <Nav bsStyle="tabs">
              {navItems}
              <NavDropdown className="hidden-md hidden-lg" eventKey="collapsed" title={this.props.translate('news.category_explorer.categories')}>
                {menuItems}
              </NavDropdown>
            </Nav>
          </Col>
        </Row>
      </Tab.Container>
    );
  }
}

NewsCategoryExplorer.displayName = 'PagesNewsCategoryExplorer';
NewsCategoryExplorer.propTypes = {};
NewsCategoryExplorer.defaultProps = {};

const mapStateToProps = (state) => {
  return { 
      translate: getTranslate(state.locale),
      currentLanguage: getActiveLanguage(state.locale).code,
      token: state.commons.token,
      context: state.commons.context,
      newsCategories: state.newsCategories,
      newsCategory: state.newsCategory
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      customerJourneyNewsCategory: bindActionCreators(customerJourneyNewsCategory, dispatch),
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NewsCategoryExplorer);



// WEBPACK FOOTER //
// ./components/pages/news/NewsCategoryExplorer.js